module.exports = __webpack_public_path__ + "img/missionaries4_2019_7-7-2021.e5947071.jpg";